export const everythingSelectedFocused = "lnTmSd";
export default {everythingSelectedFocused};